/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { Box } from 'atoms';

export default function BoxMod() {
	return <Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem"></Box>;
}

BoxMod.propTypes = {};
